import {
  Environment
} from '@vodacom/web-env';

export const Icons = {
  Checkmark: `${Environment.current.assetPath}images/icons/checkmark.svg`,
  CheckmarkThin: `${Environment.current.assetPath}images/icons/checkmark-thin.svg`,
  CheckmarkCircle: `${Environment.current.assetPath}images/icons/checkmark-circle.svg`,
  Twitter: `${Environment.current.assetPath}images/icons/twitter.svg`,
  Chevron: `${Environment.current.assetPath}images/icons/chevron.svg`,
  IconError: `${Environment.current.assetPath}images/icons/icon-error.svg`,
  Heart: `${Environment.current.assetPath}images/icons/heart.svg`,
  Retweet: `${Environment.current.assetPath}images/icons/retweet.svg`,
  Close: `${Environment.current.assetPath}images/icons/close.svg`,
  ConnectU: `${Environment.current.assetPath}images/icons/connectu-logo.svg`,
  HamburgerMenu: `${Environment.current.assetPath}images/icons/hamburger.svg`,
  LongArrow: `${Environment.current.assetPath}images/icons/long-arrow.svg`,
  Search: `${Environment.current.assetPath}images/icons/search.svg`,
  UpdownArrows: `${Environment.current.assetPath}images/icons/updown-arrows-outline.svg`,
  VodacomLogo: `${Environment.current.assetPath}images/icons/vodacom-logo.svg`,
  Wifi: `${Environment.current.assetPath}images/icons/wifi.svg`,
  Cookie: `${Environment.current.assetPath}images/icons/cookie.svg`,
  BackArrow: `${Environment.current.assetPath}images/icons/arrow.svg`,
  Jobs: `${Environment.current.assetPath}images/icons/pillars/jobs.svg`,
  Education: `${Environment.current.assetPath}images/icons/pillars/education.svg`,
  Health: `${Environment.current.assetPath}images/icons/pillars/health.svg`,
  GovernmentServices: `${Environment.current.assetPath}images/icons/pillars/government-services.svg`,
  Social: `${Environment.current.assetPath}images/icons/pillars/social.svg`,
  SafetySecurity: `${Environment.current.assetPath}images/icons/pillars/safety-security.svg`,
  SMME: `${Environment.current.assetPath}images/icons/pillars/smme.svg`,
  Buy: `${Environment.current.assetPath}images/icons/pillars/buy.svg`,
  WarningCircle: `${Environment.current.assetPath}images/icons/warning-circle.svg`,
  WarningTriangle: `${Environment.current.assetPath}images/icons/warning-triangle.svg`,
  Insight: `${Environment.current.assetPath}images/icons/bulb.svg`,
  Lightning: `${Environment.current.assetPath}images/icons/lightning-bolt.svg`,
  North: `${Environment.current.assetPath}images/icons/north-arrow.svg`,
  RedCoins: `${Environment.current.assetPath}images/icons/red-coins.svg`,
  ErrorSmall: `${Environment.current.assetPath}images/icons/Error_Small.svg`,
  SuccessCircle: `${Environment.current.assetPath}images/icons/success-circle.svg`,
  SuccessCircleOutline: `${Environment.current.assetPath}images/icons/success-circle-outline.svg`,
  WarningFilled: `${Environment.current.assetPath}images/icons/warning.svg`,
  WrongCircle: `${Environment.current.assetPath}images/icons/wrong-circle.svg`,
  InfoCircle: `${Environment.current.assetPath}images/icons/info-circle.svg`,
  CarerHi: `${Environment.current.assetPath}images/icons/carer-hi.svg`,
  Lock: `${Environment.current.assetPath}images/icons/lock.png`,
  PayNow: `${Environment.current.assetPath}images/icons/pay-now.png`,
  Advance: `${Environment.current.assetPath}images/icons/advance.png`,
  VoucherCardPattern: `${Environment.current.assetPath}images/icons/voucherCardPattern.jpg`,
  VoucherCategoryDefaultImage: `${Environment.current.assetPath}images/icons/default-category.svg`,
  ForwardArrow: `${Environment.current.assetPath}images/icons/arrow-forward.svg`,
  TriangleArrow: `${Environment.current.assetPath}images/icons/triangle-arrow.svg`,
  Just4You: `${Environment.current.assetPath}images/icons/just-4-you.svg`,
  FaceBookFlex: `${Environment.current.assetPath}images/icons/social-bundles/facebook-flex.svg`,
  Banner: `${Environment.current.assetPath}images/icons/social-bundles/banner.png`
};
